__turbopack_context__.v({
  "accordionContainer": "AccordionItemModal-module-scss-module__du4bFq__accordionContainer",
  "accordionEditing": "AccordionItemModal-module-scss-module__du4bFq__accordionEditing",
  "accordionTitle": "AccordionItemModal-module-scss-module__du4bFq__accordionTitle",
  "blocksBackgroundColor": "AccordionItemModal-module-scss-module__du4bFq__blocksBackgroundColor",
  "blocksFontColor": "AccordionItemModal-module-scss-module__du4bFq__blocksFontColor",
  "buttonLabel": "AccordionItemModal-module-scss-module__du4bFq__buttonLabel",
  "centered": "AccordionItemModal-module-scss-module__du4bFq__centered",
  "container": "AccordionItemModal-module-scss-module__du4bFq__container",
  "content": "AccordionItemModal-module-scss-module__du4bFq__content",
  "contentContainer": "AccordionItemModal-module-scss-module__du4bFq__contentContainer",
  "editableTitle": "AccordionItemModal-module-scss-module__du4bFq__editableTitle",
  "loadingIndicator": "AccordionItemModal-module-scss-module__du4bFq__loadingIndicator",
  "meritChatCallout": "AccordionItemModal-module-scss-module__du4bFq__meritChatCallout",
  "modalCloseButton": "AccordionItemModal-module-scss-module__du4bFq__modalCloseButton",
  "modalContainer": "AccordionItemModal-module-scss-module__du4bFq__modalContainer",
  "modalContent": "AccordionItemModal-module-scss-module__du4bFq__modalContent",
  "modalDialog": "AccordionItemModal-module-scss-module__du4bFq__modalDialog",
  "newsModalContainer": "AccordionItemModal-module-scss-module__du4bFq__newsModalContainer",
  "photoCarousel": "AccordionItemModal-module-scss-module__du4bFq__photoCarousel",
  "postDate": "AccordionItemModal-module-scss-module__du4bFq__postDate",
  "secondaryNavBackgroundColor": "AccordionItemModal-module-scss-module__du4bFq__secondaryNavBackgroundColor",
  "shake": "AccordionItemModal-module-scss-module__du4bFq__shake",
  "subheader": "AccordionItemModal-module-scss-module__du4bFq__subheader",
  "themeBackgroundColor": "AccordionItemModal-module-scss-module__du4bFq__themeBackgroundColor",
  "themeFontColor": "AccordionItemModal-module-scss-module__du4bFq__themeFontColor",
  "titleContainer": "AccordionItemModal-module-scss-module__du4bFq__titleContainer",
  "transitionAppear": "AccordionItemModal-module-scss-module__du4bFq__transitionAppear",
  "transitionAppearActive": "AccordionItemModal-module-scss-module__du4bFq__transitionAppearActive",
  "transitionAppearDone": "AccordionItemModal-module-scss-module__du4bFq__transitionAppearDone",
  "transitionEnter": "AccordionItemModal-module-scss-module__du4bFq__transitionEnter",
  "transitionEnterActive": "AccordionItemModal-module-scss-module__du4bFq__transitionEnterActive",
  "transitionEnterDone": "AccordionItemModal-module-scss-module__du4bFq__transitionEnterDone",
  "transitionExit": "AccordionItemModal-module-scss-module__du4bFq__transitionExit",
  "transitionExitActive": "AccordionItemModal-module-scss-module__du4bFq__transitionExitActive",
  "transitionExitDone": "AccordionItemModal-module-scss-module__du4bFq__transitionExitDone",
});
